export default __webpack_public_path__ + "static/media/2-Benjamin-Abrahão-Lampião-e-M-Bonita-1936-IMS.55f3e419.jpg";